<template>
  <div id="app">
    <router-view :key="key"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed:{
    //保证路由切换时都会重新渲染钩子函数
    key(){
      return this.$route.name !== undefined ? this.$route.name + +new Date(): this.$route + +new Date()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue